import Svg, { Path } from 'react-native-svg'

/** The Apple mark, for a Sign in with Apple button. Takes the label's colour. */
export const AppleMark = ({
	size = 18,
	color = '#FFFFFF',
}: { size?: number; color?: string }) => (
	<Svg width={size} height={size} viewBox="0 0 24 24">
		<Path
			fill={color}
			d="M16.365 1.43c0 1.14-.42 2.2-1.24 3.13-.9 1.03-2.02 1.62-3.2 1.53-.02-.13-.03-.27-.03-.42 0-1.1.47-2.27 1.31-3.19.42-.47.95-.86 1.6-1.17.64-.3 1.25-.47 1.83-.5.02.2.03.4.03.62zm3.87 16.53c-.36.83-.79 1.6-1.29 2.3-.68.96-1.24 1.63-1.67 2-.66.61-1.37.92-2.13.94-.55 0-1.21-.16-1.98-.47-.77-.32-1.48-.47-2.13-.47-.68 0-1.41.16-2.19.47-.78.32-1.41.48-1.89.5-.73.03-1.46-.29-2.18-.96-.46-.4-1.05-1.09-1.75-2.08-.75-1.05-1.37-2.27-1.85-3.66-.52-1.5-.78-2.96-.78-4.37 0-1.61.35-3 1.05-4.16.55-.93 1.28-1.67 2.2-2.21.92-.54 1.91-.82 2.98-.84.58 0 1.34.18 2.29.53.95.35 1.56.53 1.83.53.2 0 .87-.21 2.02-.62 1.08-.38 1.99-.54 2.74-.48 2.03.16 3.56.96 4.57 2.41-1.82 1.1-2.72 2.65-2.7 4.63.02 1.54.58 2.83 1.67 3.85.5.47 1.05.84 1.66 1.1-.13.38-.27.75-.42 1.1z"
		/>
	</Svg>
)

/** Google's four-colour G, for a Continue with Google button. Always in its own colours. */
export const GoogleMark = ({ size = 18 }: { size?: number }) => (
	<Svg width={size} height={size} viewBox="0 0 48 48">
		<Path
			fill="#EA4335"
			d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.6 2.5 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.8 6C12.3 13.2 17.7 9.5 24 9.5z"
		/>
		<Path
			fill="#4285F4"
			d="M46.5 24.5c0-1.6-.1-2.8-.4-4H24v8.1h12.8c-.3 2.1-1.7 5.3-4.8 7.4l7.4 5.7c4.4-4.1 7.1-10.1 7.1-17.2z"
		/>
		<Path
			fill="#FBBC05"
			d="M10.4 28.8A14.6 14.6 0 0 1 9.5 24c0-1.7.3-3.3.8-4.8l-7.8-6A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.8l7.8-6z"
		/>
		<Path
			fill="#34A853"
			d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.4-5.7c-2 1.4-4.7 2.4-8.5 2.4-6.3 0-11.7-3.7-13.6-9.1l-7.8 6C6.5 42.6 14.6 48 24 48z"
		/>
	</Svg>
)
